import { Component, OnInit } from '@angular/core';
import { EventEmitterTimesheetBo } from './timesheet.model';
@Component({
  selector: 'app-timesheet',
  templateUrl: './timesheet.component.html',
  styleUrls: ['./timesheet.component.scss']
})
export class TimesheetComponent implements OnInit {
  TimesheetVieworEntry: boolean = false;
  constructor() {
  }
  ngOnInit(): void {
  }
  isListorUpdateView: EventEmitterTimesheetBo = {
    isEntry: false,
    LocationLid:0,
    serviceList:null,
    ClientDropDown:null,
    EmployeeDropDown:null,
    EmployeeUMPI:null,
    serviceGroupList:null,
    PayorDropDown:null,
    ServiceCode:null,
    ActiveInactiveClient:null
  };
  EmitChildComponent(event: EventEmitterTimesheetBo) {
    this.TimesheetVieworEntry = event.isEntry;
    this.isListorUpdateView = event;
  }
}
